import {
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useParams } from "react-router-dom";
import { useGetAllMeetingsQuery } from "../../../redux/Hire/candidateMeetingApi";
import {
  CandidateDetails,
  useGetJobRequestByIdQuery,
} from "../../../redux/Hire/jobRequestApi";
import { CloseIcon } from "../../../shared/components/Icons";
import { HiringStageCode } from "../../../utils/constants";
import ScheduleCall from "../../HireV3/ScheduleCall";
import ScheduleCallDetails from "../../HireV3/ScheduleCallDetails";
import ScheduleCallDelete from "../../HireV3/ScheduledCallDelete";

type Props = {
  candidate?: CandidateDetails;
  closeBox?: () => void; // Optional prop to close the dialog
};

const ScheduleCallDialog = ({ candidate, closeBox }: Props) => {
  const { data, isFetching, isError, refetch } = useGetAllMeetingsQuery({
    candidateId: candidate?.id.toString() || "",
    candidateStage: HiringStageCode.SHORTLIST,
  });

  const { id } = useParams();

  const { data: jobRequestData } = useGetJobRequestByIdQuery({
    jobRequestId: Number(id) || 0,
  });

  const [showReschedule, setShowReschedule] = useState(false);
  const [showDeleteReason, setShowDeleteReason] = useState(false);

  const openDeleteReason = useCallback(() => {
    setShowReschedule(false);
    setShowDeleteReason(true);
  }, []);
  const closeDeleteReason = useCallback(() => {
    setShowDeleteReason(false);
    closeBox?.();
  }, [closeBox]);

  const openReschedule = useCallback(() => {
    setShowReschedule(true);
  }, []);
  const closeReschedule = useCallback(() => {
    setShowReschedule(false);
    closeBox?.();
  }, [closeBox]);
  const closeDeleteReasonAndOpenReschedule = useCallback(() => {
    setShowDeleteReason(false);
    setShowReschedule(true);
  }, []);
  useEffect(() => {
    refetch();
  }, [candidate?.id, refetch]);

  const alert = useAlert();

  useEffect(() => {
    if (isError) {
      alert.error("Error fetching interview details");
    }
  }, [alert, isError]);

  return (
    <Grid
      sx={{
        minWidth: 275,

        width: "100%",
      }}
    >
      <Grid
        container
        gap={2}
        sx={{
          justifyContent: "flex-start",
          minHeight: 52,
        }}
      >
        <Grid
          item
          xs={12}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="subtitle2" component="div">
            Schedule call with candidate
          </Typography>
          {closeBox ? (
            <IconButton
              aria-label="close"
              onClick={closeBox}
              size="small"
              sx={{
                color: "black",
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </Grid>
      </Grid>
      <Divider />
      <Grid
        px={0}
        py={2}
        container
        flexDirection={"column"}
        alignItems={"center"}
        className="tbl-body"
        gap={2}
      >
        {isFetching && <CircularProgress size={36}></CircularProgress>}
        {(data?.data.length || 0) > 0 && !isFetching && (
          <ScheduleCallDetails
            meetingDetails={data?.data[0]}
            openReschedule={openReschedule}
            openDeleteReason={openDeleteReason}
          ></ScheduleCallDetails>
        )}
        {((data?.data.length || 0) === 0 || showReschedule) &&
          !showDeleteReason &&
          !isFetching && (
            <ScheduleCall
              candidateId={candidate?.id.toString() || ""}
              candidateName={candidate?.fullname || ""}
              clientId={jobRequestData?.data.clientId.toString() || ""}
              clientName={jobRequestData?.data.client || ""}
              jobId={id || ""}
              jobVersion={jobRequestData?.data.version || 0}
              roleName={jobRequestData?.data.title || ""}
              candidateEmail={candidate?.email || ""}
              meetingDetails={data?.data[0]}
              closeReschedule={closeReschedule}
              recruiterEmail={jobRequestData?.data.recruiter || ""}
              recruiterName={jobRequestData?.data.recruiter || ""}
              setSelectedStage={() => {}}
              allowStageUpdate={candidate?.stage === "screeningByTalentTeam"}
              selectedStage={candidate?.stage || ""}
            ></ScheduleCall>
          )}

        {showDeleteReason && (
          <ScheduleCallDelete
            closeDeleteReason={closeDeleteReason}
            candidateId={candidate?.id.toString() || ""}
            meetingDetails={data?.data[0]}
            closeDeleteReasonAndOpenReschedule={
              closeDeleteReasonAndOpenReschedule
            }
          />
        )}
      </Grid>
    </Grid>
  );
};

export default memo(ScheduleCallDialog);
